module.exports = __webpack_public_path__ + "static/media/water-delivery-GIS-04.eb445074.jpg";